import React from 'react';
import { OnboardingFlow } from '@/components/auth/OnboardingFlow';

export const Onboarding: React.FC = () => {
  return <OnboardingFlow />;
};